var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"text-left",attrs:{"variant":"dark"}},[_c('b-icon',{attrs:{"icon":_vm.icon}}),_vm._v(" "+_vm._s(_vm.type.toUpperCase())+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }